import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, FormControl } from 'react-bootstrap';

const QuantityLine = props => {
  const { label, initialQty, updateLine, lineNumber } = props;
  const [qty, setQty] = useState(initialQty || 0);

  const handleDecrement = () => {
    const newQty = qty - 1;
    if (newQty < 0) {
      return;
    }

    setQty(newQty);
  };

  const handleIncrement = () => {
    const newQty = qty + 1;
    setQty(newQty);
  };

  const onQtyChange = event => {
    if (String(event.target.value).length > 4) {
      return;
    }

    if (event.target.value === '') {
      setQty(0);
      return;
    }

    const newQty = parseInt(event.target.value);

    if (isNaN(newQty)) {
      return;
    }

    setQty(parseInt(event.target.value));
  };

  useEffect(() => {
    updateLine(qty, lineNumber);
  }, [qty]);

  return (
    <div className="alt-bin">
      <div className="alt-bin-name">{label}</div>
      <div className="alt-bin-controls">
        <div className={`decrement ${qty === 0 && 'disabled'}`} onClick={handleDecrement}>
          <i className="zmdi zmdi-minus" />
        </div>
        <div className="quant">
          <FormGroup>
            <FormControl onChange={onQtyChange} value={qty} />
          </FormGroup>
        </div>
        <div className="increment" onClick={handleIncrement}>
          <i className="zmdi zmdi-plus" />
        </div>
      </div>
    </div>
  );
};

QuantityLine.propTypes = {
  label: PropTypes.string,
  initialQty: PropTypes.number,
  updateLine: PropTypes.func,
  lineNumber: PropTypes.number,
};

export default QuantityLine;
